export const SectionNameOptions = [
    {
        label: "Pop Section Names (流行段落名称)",
        children: [
            { label: "Blank Section (空白/留白)" },
            { label: "Intro (前奏)" },
            { label: "Verse (主歌)" },
            { label: "Pre-Chorus (导歌/预副歌)" },
            { label: "Chorus (副歌)" },
            { label: "Bridge (桥段)" },
            { label: "Interlude (间奏)" },
            { label: "Outro (尾奏)" }
        ]
    },
    {
        label: "Classical Section Names (古典段落名称)",
        children: [
            {
                label: "Sonata Sections (奏鸣曲段落)",
                children: [
                    { label: "Intro (前奏)" },
                    { label: "Exposition (呈示部)" },
                    { label: "Development (展开部)" },
                    { label: "Recapitulation (再现部)" },
                    { label: "Coda (尾声)" }
                ]
            },
            {
                label: "Theme and Variations (主题和变奏)",
                children: [
                    { label: "Theme (主题)" },
                    { label: "Variation (变奏)" }
                ]
            }
        ]
    },
    {
        label: "Jazz Section Names (爵士段落名称)",
        children: [
            { label: "Intro (前奏)" },
            { label: "Head" },
            { label: "Solo" },
            { label: "Coda (尾声)" }
        ]
    },
    {
        label: "Letter Representations (AB段表示)",
        children: [
            { label: "A" },
            { label: "B" },
            { label: "C" },
            { label: "D" }
        ]
    }
];

export const RhythmicStyleOptions = [
    { label: "摇滚 (Rock)" },
    { label: "流行 (Pop)" },
    { label: "DJ" },
    { label: "节奏布鲁斯 (R&B)" },
    { label: "House (i.e., Four-on-the-Floor / Techno)" },
    { label: "放克 (Funk)" },
    { label: "Swing" },
    { label: "Shuffle" },
    { label: "雷鬼 (Reggae)" },
    { label: "Trap" },
    { label: "朋克 (Punk)" },
    { label: "金属 (Metal)" },
    { label: "拉丁 (Latin) / 波萨诺瓦 (Bossa Nova)" },
    { label: "雷吉顿 (Reggaeton) / Moombahton / Tresillo" },
    { label: "Afrobeats" },
    { label: "圆舞曲/华尔兹 (Waltz)" },
    { label: "进行曲 (March)" },
    { label: "常规古典节奏 (Regular Classical Music Rhythm)" },
    { label: "非上述节奏 (Other Rhythm Types)" }
];

export const MusicStructureAnnotationFormAttributes = {
    Structure: [
        {
            name: "section_name",
            questionText: "Section Name (段落名称)",
            type: "multiple-choice",
            mandatory: true,
            items: SectionNameOptions,
            allowAnyLevelSelection: false,
            singleSelect: true,
            instruction: `- 对于不同类型的音乐，您可以采用不同的段落名称选择体系。例如，对于流行音乐您可以选择主歌、副歌等段落；对于古典音乐、爵士乐，您也可以找到合适的体系
如果您认为以上体系都不适合这首音乐，您也可以将这些段落名称选择为ABCD
- For different types of music, you may use different section naming systems. For example:
 For pop music, use section names like Verse, Chorus, Bridge, etc.
 For classical or jazz music, use appropriate structural terms from those traditions.
If none of the predefined section names seem suitable, you can label sections using A, B, C, D`
        },
        {
            name: "rhythmic_style",
            questionText: "Rhythmic Style (节奏风格)",
            type: "multiple-choice",
            mandatory: true,
            items: RhythmicStyleOptions,
            allowAnyLevelSelection: true,
            singleSelect: true,
            instruction: `请您选择一种最合适的节奏风格来概括此段落的节奏类型。其中有些选项比起节奏风格可能更接近于曲风，但我们想要表达的是：这些选项分别都可以代表一种或一类具有独特风格的节奏。
            Select the most appropriate rhythmic style to describe the rhythm of this section. Some choices may overlap with genres (e.g., "Swing" or "Reggae"), but they still represent distinct rhythmic patterns.`
        },
        {
            name: "harmonic_progression_verbal_description",
            questionText: "Verbal Description of Harmonic Progression (和声口语描述)",
            type: "free-response",
            mandatory: false,
            instruction: `使用日常化的语言来描述这一段落使用的和声走向。
            Use everyday language to describe the harmonic progression of this section.
            Example 1: 4536251
            Example 2: IV - V - iii - vi - ii - V - I
            Example 3: 这段使用了卡农走向，其中在5级和3级处分别使用替代251。`
        },
        {
            name: "section_description",
            questionText: "Section Description (段落描述)",
            type: "free-response",
            mandatory: true,
            instruction: `请用一段文字描述该段落的编曲，可以从和声进行、节奏特点、旋律走向、配器编排等方面展开。
            Please describe the arrangement of this section in a few sentences, considering aspects such as harmony, rhythm, melody, and instrumentation.
            "例1: 这是第一遍主歌，呈现出典型的 Funk 律动，和声采用 Fm - C - E - Am 进行。配器方面，Rhodes 电钢琴以柱式和弦铺陈和声，萨克斯演奏主旋律，并在第三拍使用水滴音效。
            Example 1: This is the first verse, featuring a characteristic Funk groove with a harmonic progression of Fm - C - E - Am. In terms of instrumentation, the Rhodes electric piano provides harmonic support with block chords, while the saxophone plays the main melody. Meanwhile, a water drop sound effect is subtly incorporated on the third beat.`
        }
    ]
}
